// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayer-h5progress-bubble.bubble-hide {\n  visibility: hidden;\n}\n\n.vhallPlayer-h5progress-bubble.bubble-show {\n  visibility: visible;\n  position: absolute;\n  width: 80px;\n  height: 22px;\n  background-color: black;\n  opacity: 0.65;\n  left: 53%;\n  top: -80%;\n  transform: translate(-50%, -50%);\n}", ""]);
// Exports
module.exports = exports;
